import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_ENCOUNTER_PATIENT_MIGRATION_STRATEGIES: MigrationStrategies =
  {
    // v0 → v1: added optional `dob` field (defaults to null for existing records)
    1: (oldDoc) => ({ ...oldDoc, dob: oldDoc.dob ?? null }),
    // v1 → v2: added optional `gender` field — default null for existing records
    2: (oldDoc) => ({ ...oldDoc, gender: oldDoc.gender ?? null }),
    3: (oldDoc) => oldDoc,
  };
